/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourceKeyPublic } from './ResourceKeyPublic';

export const ListKeyPublic: core.serialization.ObjectSchema<serializers.ListKeyPublic.Raw, Truvity.ListKeyPublic> =
    core.serialization.object({
        items: core.serialization.list(ResourceKeyPublic),
    });

export declare namespace ListKeyPublic {
    export interface Raw {
        items: ResourceKeyPublic.Raw[];
    }
}
